module.exports = __webpack_public_path__ + "static/media/client-01.5f0c6b2a.png";